import { DateTime } from 'luxon'
import { PatientHistoryType } from 'src/graphql.generated'
import { PatientHistoryEntry } from '../api/useAdvancedPatientHistory'

const at = (daysAgo: number) =>
  DateTime.now().minus({ days: daysAgo }).set({ hour: 10, minute: 15, second: 0, millisecond: 0 }).toJSDate()

const entry = (id: string, daysAgo: number, type: PatientHistoryType, description: string): PatientHistoryEntry => ({
  __typename: 'CommonPatientHistory',
  entryID: id,
  coachID: null,
  type,
  date: DateTime.now().minus({ days: daysAgo }).toISODate(),
  createdAt: at(daysAgo),
  source: null,
  value: { description },
  files: [],
})

// Oldest last, as `patientHistory` is ordered date descending.
export const exampleHistoryEntries = (): PatientHistoryEntry[] => [
  entry(
    'example:note',
    1,
    PatientHistoryType.Note,
    'Talked through the evening routine. Sleep has been more regular this week.'
  ),
  entry(
    'example:call',
    6,
    PatientHistoryType.PhoneCall,
    'Check-in call. Mood is steadier, and the breakfast log is in.'
  ),
]
